import i18n from 'services/i18n'
import singleCertificateHelper from '../helpers/singleCertificateHelper'
import listCertificateHelper from '../helpers/listCertificateHelper'
import { formattedDateForCountry } from 'components/shared/mixins/dateHelper'

const unitForHour = 't'
const mapAuthorizationTypeToShortLabel = (authorizationType) => {
    switch (authorizationType.toLowerCase()) {
    case 'aktualitetstimmar redovisningskonsult: redovisning':
        return i18n.t('CertificateList.se_accounting_label')
    case 'aktualitetstimmar redovisningskonsult: skatt':
        return i18n.t('CertificateList.se_tax_label')
    case 'aktualitetstimmar lönekonsult: lön':
    case 'lön':
        return i18n.t('CertificateList.se_payroll_label')
    }
    return ''
}

function createSingleCertificate (course) {
    let certificate = singleCertificateHelper.getNewPdfObject()
    certificate = singleCertificateHelper.setupNewPdfPage(certificate)
    singleCertificateHelper.resetStartCoordinate()

    singleCertificateHelper.setCertificateLabel(certificate, course)
    singleCertificateHelper.setCompletedOnDate(certificate, course)
    singleCertificateHelper.setCourseTitle(certificate, course)
    singleCertificateHelper.setCourseDescription(certificate, course)
    singleCertificateHelper.setUserNameHasCompletedCourse(certificate, course)
    singleCertificateHelper.setCourseInstructor(certificate, course)
    singleCertificateHelper.setCourseType(certificate, course, singleCertificateHelper.isLearningPath(course))
    singleCertificateHelper.setCoursePublishDate(certificate, course, singleCertificateHelper.isLearningPath(course))
    singleCertificateHelper.setCourseCategories(certificate, course, singleCertificateHelper.isLearningPath(course))
    singleCertificateHelper.setCourseLevel(certificate, course)
    singleCertificateHelper.setCourseDuration(certificate, course, 't')
    singleCertificateHelper.setAuthorizations(certificate, course, singleCertificateHelper.isLearningPath(course))
    singleCertificateHelper.setContactInfo(certificate)
    if (singleCertificateHelper.isDigitalClassRoom(course)) {
        singleCertificateHelper.setDigitalClassRoomTrainingDate(certificate, course)
    }

    if (singleCertificateHelper.isLearningPath(course)) {
        singleCertificateHelper.addInfoTextForListOfCourses(certificate)

        let pageNumber = 1
        let courseListNumber = 1
        let rowCoordinate = 72
        let totalDuration = 0

        singleCertificateHelper.addPageNumber(certificate, pageNumber)
        pageNumber++
        certificate.addPage()
        listCertificateHelper.setupNewPdfPage(certificate)
        listCertificateHelper.addPageNumber(certificate, pageNumber)
        listCertificateHelper.addLearningPathCourseListParagraph(certificate, course.learningPathName)
        listCertificateHelper.setCertificateListLabel(certificate, true)
        certificate = listCertificateHelper.setColumnLabels(certificate)
        singleCertificateHelper.setContactInfo(certificate)

        course.courseCertificates.forEach((courseCertificate) => {
            if (rowCoordinate > 219) {
                rowCoordinate = 72
                pageNumber += 1
                certificate.addPage()
                listCertificateHelper.setupNewPdfPage(certificate)
                listCertificateHelper.addPageNumber(certificate, pageNumber)
            }
            certificate.setFontSize(10)
            certificate.setFont('Nunito-Regular')
            certificate.setTextColor('black')
            certificate.text(11, rowCoordinate, courseListNumber.toString() + '.')
            let splitTitle = certificate.splitTextToSize(courseCertificate.courseTitle.replace(/"/g, ''), 90)
            certificate.text(18, rowCoordinate, splitTitle)

            if (courseCertificate.durations.length > 0) {
                let certSingleAmount = 0
                let certRowCooridinate = rowCoordinate
                const certsList = []
                courseCertificate.durations.forEach((authorization) => {
                    const authorizationLabel = mapAuthorizationTypeToShortLabel(authorization.category)
                    certSingleAmount += +authorization.credits
                    certsList.push(authorizationLabel)
                })

                let uniqCertList = [...new Set(certsList)]
                uniqCertList.forEach((cert) => {
                    if (cert) {
                        certificate.text(127, certRowCooridinate, cert)
                        certRowCooridinate += 4
                    }
                })
                certificate.text(157, rowCoordinate, certSingleAmount.toString())
            }
            certificate.text(178, rowCoordinate, formattedDateForCountry(courseCertificate.date))
            certificate.setFontSize(8)
            certificate.setFont('Nunito-Regular')
            // Apply the space for titles longer than 1 row
            rowCoordinate += (4 * (splitTitle.length - 1))

            if (courseCertificate.instructors?.length > 0 && courseCertificate.duration !== null && courseCertificate.courseTypeValue) {
                certificate.text(18, (rowCoordinate + 4), singleCertificateHelper.getInstructors(courseCertificate).replace(/"/g, '') +
                    ' | ' + singleCertificateHelper.getCourseType(courseCertificate.courseTypeValue) + ' | ' +
                    listCertificateHelper.convertMinutesToHours(courseCertificate.duration, unitForHour))
            }
            courseListNumber += 1

            if (courseCertificate.durations.length > 2) {
                rowCoordinate += (4 * (courseCertificate.durations.length)) + 1
            } else {
                rowCoordinate += 10
            }
            if (courseCertificate.duration) {
                totalDuration += parseInt(courseCertificate.duration)
            }
        })
        certificate = listCertificateHelper.setTotalWatchedAmountLabel(certificate, totalDuration, 'h', singleCertificateHelper.isLearningPath(course))
    }

    certificate.setProperties({
        title: i18n.t('Certificates.training_certificate')
    })
    window.open(certificate.output('bloburl'))
}

function createListCertificate (filteredCourseList) {
    let certificate = singleCertificateHelper.getNewPdfObject()
    listCertificateHelper.setupNewPdfPage(certificate)
    let courseListNumber = 1
    let rowCoordinate = 72
    let pageNumber = 1
    let totalDuration = 0

    listCertificateHelper.setCertificateListLabel(certificate)
    listCertificateHelper.setUserNameHasCompletedCourses(certificate, filteredCourseList)
    listCertificateHelper.setColumnLabels(certificate)

    let authorizationAmount = 0
    let lonAmount = 0
    let skattAmount = 0
    let courseIds = []

    if (filteredCourseList.learningPaths.length > 0) {
        listCertificateHelper.addCourseTypeSubHeader('', certificate, (rowCoordinate - 7), i18n.t('CertificateList.course_type_learning_paths'))
    }

    filteredCourseList.learningPaths.forEach((learningPath) => {
        courseListNumber = 1
        if (rowCoordinate > 219) {
            listCertificateHelper.addPageNumber(certificate, pageNumber)
            rowCoordinate = 72
            pageNumber += 1
            certificate.addPage()
            listCertificateHelper.setupNewPdfPage(certificate)
            listCertificateHelper.addPageNumber(certificate, pageNumber)
            listCertificateHelper.setColumnLabels(certificate)
        }
        certificate.setFont('icomoon')
        certificate.setFontSize(11)
        certificate.text(12, rowCoordinate, '')
        certificate.setFont('Quicksand-Bold')
        certificate.setFontSize(10)
        let splitTitle = certificate.splitTextToSize(learningPath.title.replace(/"/g, ''), 90)
        certificate.text(19, rowCoordinate, splitTitle)
        certificate.setFontSize(9)
        certificate.setFont('Quicksand-Bold')
        certificate.text(180, rowCoordinate, formattedDateForCountry(learningPath.certificate.date))
        rowCoordinate += 6

        learningPath.certificate.courseCertificates.forEach((courseCertificate) => {
            certificate.setFontSize(10)
            certificate.setFont('Nunito-Regular')
            certificate.text(22, rowCoordinate, courseListNumber.toString() + '.')
            let splitTitle = certificate.splitTextToSize(courseCertificate.courseTitle.replace(/"/g, ''), 90)
            certificate.text(28, rowCoordinate, splitTitle)

            certificate.setFontSize(9)

            if (courseCertificate.durations.length > 0) {
                let payrollCertAlreadyAdded = false
                let certSingleAmount = 0
                let certRowCooridinate = rowCoordinate
                courseCertificate.durations.forEach((authorization) => {
                    certSingleAmount += +authorization.credits
                    const categoryLowerCase = authorization.category.toLowerCase()
                    switch (categoryLowerCase) {
                    case 'aktualitetstimmar redovisningskonsult: redovisning':
                        authorizationAmount += +authorization.credits
                        break
                    case 'aktualitetstimmar redovisningskonsult: skatt':
                        skattAmount += +authorization.credits
                        break
                    case 'lön':
                    case 'aktualitetstimmar lönekonsult: lön':
                        if (payrollCertAlreadyAdded) {
                            break
                        }
                        lonAmount += +authorization.credits
                        payrollCertAlreadyAdded = true
                        break
                    }
                    certificate.text(127, certRowCooridinate, mapAuthorizationTypeToShortLabel(categoryLowerCase))
                    certRowCooridinate += 4
                })
                certSingleAmount = certSingleAmount.toFixed(2)
                certificate.text(157, rowCoordinate, certSingleAmount.toString())
            }
            certificate.text(180, rowCoordinate, formattedDateForCountry(courseCertificate.date))
            certificate.setFontSize(8)
            certificate.setFont('Nunito-Regular')

            // Apply the space for titles longer than 1 row
            rowCoordinate += (4 * (splitTitle.length - 1))

            if (courseCertificate.instructors?.length > 0 && courseCertificate.duration !== null && courseCertificate.courseTypeValue) {
                certificate.text(28, (rowCoordinate + 4), singleCertificateHelper.getInstructors(courseCertificate).replace(/"/g, '') +
                    ' | ' + singleCertificateHelper.getCourseType(courseCertificate.courseTypeValue) + ' | ' +
                    listCertificateHelper.convertMinutesToHours(courseCertificate.duration, unitForHour))
            }
            courseListNumber += 1
            if (courseCertificate.durations.length > 2) {
                rowCoordinate += (4 * (courseCertificate.durations.length)) + 1
            } else {
                rowCoordinate += 10
            }
            if (courseCertificate.duration) {
                totalDuration += parseInt(courseCertificate.duration)
            }
            courseIds.push(courseCertificate.courseId)
            if (rowCoordinate > 219) {
                listCertificateHelper.addPageNumber(certificate, pageNumber)
                rowCoordinate = 72
                pageNumber += 1
                certificate.addPage()
                listCertificateHelper.setupNewPdfPage(certificate)
                listCertificateHelper.addPageNumber(certificate, pageNumber)
                listCertificateHelper.setColumnLabels(certificate)
            }
        })
    })

    rowCoordinate += 7
    courseListNumber = 1
    const listableCourses = filteredCourseList.courses.filter(course => !courseIds.includes(course.id))
    if (listableCourses.length > 0) {
        listCertificateHelper.addCourseTypeSubHeader('', certificate, (rowCoordinate - 7), i18n.t('CertificateList.course_type_courses'))
    }

    listableCourses.forEach((course) => {
        if (rowCoordinate > 219) {
            rowCoordinate = 72
            listCertificateHelper.addPageNumber(certificate, pageNumber)
            pageNumber += 1
            certificate.addPage()
            listCertificateHelper.setupNewPdfPage(certificate)
            listCertificateHelper.addPageNumber(certificate, pageNumber)
            listCertificateHelper.setColumnLabels(certificate)
        }
        certificate.setFontSize(10)
        certificate.setFont('Nunito-Regular')
        certificate.text(12, rowCoordinate, courseListNumber.toString() + '.')
        let splitTitle = certificate.splitTextToSize(course.certificate.courseTitle.replace(/"/g, ''), 90)
        certificate.text(19, rowCoordinate, splitTitle)
        if (course.certificate.durations.length > 0) {
            let payrollCertAlreadyAdded = false
            let certSingleAmount = 0
            let certsList = []
            let certRowCooridinate = rowCoordinate
            course.certificate.durations.forEach((authorization) => {
                switch (authorization.category.toLowerCase()) {
                case 'aktualitetstimmar redovisningskonsult: redovisning':
                    authorizationAmount += +authorization.credits
                    certSingleAmount += +authorization.credits
                    certsList.push(i18n.t('CertificateList.se_accounting_label'))
                    break
                case 'aktualitetstimmar redovisningskonsult: skatt':
                    skattAmount += +authorization.credits
                    certSingleAmount += +authorization.credits
                    certsList.push(i18n.t('CertificateList.se_tax_label'))
                    break
                case 'lön':
                case 'aktualitetstimmar lönekonsult: lön':
                    if (payrollCertAlreadyAdded) {
                        break
                    }
                    lonAmount += +authorization.credits
                    certSingleAmount += +authorization.credits
                    certsList.push(i18n.t('CertificateList.se_payroll_label'))
                    payrollCertAlreadyAdded = true
                    break
                }
            })
            let uniqCertList = [...new Set(certsList)]
            uniqCertList.forEach((cert) => {
                certificate.text(127, certRowCooridinate, cert)
                certRowCooridinate += 4
            })
            certSingleAmount = certSingleAmount.toFixed(2)
            certificate.text(157, rowCoordinate, certSingleAmount.toString())
        }
        certificate.text(180, rowCoordinate, formattedDateForCountry(course.certificate.date))
        certificate.setFontSize(8)
        certificate.setFont('Nunito-Regular')
        // Apply the space for titles longer than 1 row
        rowCoordinate += (4 * (splitTitle.length - 1))
        if (course.instructors?.length > 0 && course.duration !== null && course.courseTypeValue) {
            certificate.text(19, (rowCoordinate + 4), singleCertificateHelper.getInstructors(course).replace(/"/g, '') +
                ' | ' + singleCertificateHelper.getCourseType(course.courseTypeValue) + ' | ' +
                listCertificateHelper.convertMinutesToHours(course.duration, unitForHour))
        }
        courseListNumber += 1
        if (course.certificate.durations.length > 2) {
            rowCoordinate += (4 * (course.certificate.durations.length)) + 1
        } else {
            rowCoordinate += 10
        }

        if (course.duration) {
            totalDuration += parseInt(course.duration)
        }

        // Commented out to match how production behaves now :)
        // if (course.authorizationId !== '' && course.authorizationId !== null && course.authorizationId !== undefined) {
        //     certificate.setFont('Nunito-Bold')
        //     certificate.text(18, (rowCoordinate + 4), 'SRF ID: ')
        //     certificate.setFont('Nunito-Regular')
        //     certificate.text(28, (rowCoordinate + 4), course.authorizationId)
        // }
    })

    certificate.setTextColor('white')
    certificate.setFontSize(14)
    certificate.text(11, 236, i18n.t('CertificateList.courses_watched_total') + ' ' + listCertificateHelper.convertMinutesToHours(totalDuration, unitForHour))

    certificate.setFontSize(12)
    let startY = 256 // Initial Y-coordinate
    let lineSpacing = 9 // Space between lines
    function addCertificateText (certificate, amount, textKey, yPosition) {
        if (amount > 0) {
            certificate.setTextColor('black')
            certificate.text(12, yPosition, i18n.t(textKey) + ' ' + amount)
        }
    }

    let yPosition = startY
    addCertificateText(certificate, authorizationAmount, 'CertificateList.se_authorizations_total_accounting', yPosition)
    if (authorizationAmount > 0) {
        yPosition += lineSpacing
    }
    addCertificateText(certificate, lonAmount, 'CertificateList.se_authorizations_total_payroll', yPosition)
    if (lonAmount > 0) {
        yPosition += lineSpacing
    }
    addCertificateText(certificate, skattAmount, 'CertificateList.se_authorizations_total_tax_vat', yPosition)

    certificate = singleCertificateHelper.setContactInfo(certificate)

    certificate.setProperties({
        title: i18n.t('Certificates.training_certificate_list')
    })
    window.open(certificate.output('bloburl'))
}

export default {
    createSingleCertificate,
    createListCertificate,
}
